import { createSlotRecipe } from './runtime.js';

const chatBranchPickerConfig = {"name":"chatBranchPicker","slots":["root"]}

export const chatBranchPicker = /* @__PURE__ */ createSlotRecipe(chatBranchPickerConfig)